import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store';
import { selectAllSettings } from '@app/store/settings/selectors/settings.selectors';
import { resetSettings, updateUserSettings } from '@app/store/settings/actions/settings.actions';
import { Settings } from '@app/store/settings/reducers/settings.reducer';

@Injectable({
  providedIn: 'root'
})
export class SettingsFacade {
  constructor(private store: Store<AppState>) {}

  getDisplaySettings() {
    return this.store.select(selectAllSettings);
  }

  setUserSettings(settings: Settings) {
    this.store.dispatch(updateUserSettings(settings));
  }

  resetSettings() {
    this.store.dispatch(resetSettings());
  }
}
